var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import InlineInput from '../inline-input/InlineInput';
import FAIcon from '../icons/FAIcon';
import styles from './editor-workspaces.module.scss';
let EditorWorkspaces = class EditorWorkspaces extends React.Component {
    constructor() {
        super(...arguments);
        this.changeWorkspace = (ws) => {
            return () => this.props.store.changeWorkspace(ws);
        };
        this.renameWorkspace = (ws) => {
            return (newName) => ws.name = newName;
        };
        this.deleteWorkspace = (ws) => {
            return () => this.props.store.deleteWorkspace(ws);
        };
    }
    render() {
        const { workspaces, createWorkspace, rootDir, showSelectDir } = this.props.store;
        let wsDir;
        if ('true' === process.env.TARGET_ELECTRON) {
            wsDir = React.createElement("div", { className: styles.rootDir, onClick: showSelectDir, title: rootDir }, rootDir);
        }
        return (React.createElement("div", { className: styles.root },
            wsDir,
            React.createElement("ul", { className: styles.list },
                workspaces.map((ws, i) => (React.createElement("li", { key: i, className: cx(styles.item, styles.workspace, { [styles.active]: ws.isActive }), onClick: this.changeWorkspace(ws) },
                    React.createElement(InlineInput, { className: styles.input, value: ws.name, validate: /[\w]+/, onCommit: this.renameWorkspace(ws) }),
                    React.createElement(FAIcon, { className: cx(styles.delete, 'fa', 'fa-times'), onClick: this.deleteWorkspace(ws) })))),
                React.createElement("li", { className: cx(styles.item, styles.new) },
                    React.createElement(InlineInput, { className: styles.input, value: "New workspace", validate: /[\w]+/, onCommit: createWorkspace })))));
    }
};
EditorWorkspaces = __decorate([
    observer
], EditorWorkspaces);
export default EditorWorkspaces;
